
import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "Card",
  props: {
    imageUrl: {
      type: String,
      default: "",
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["click"]
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "12f80062": (_ctx.imageUrl)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__